import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import { useWizardContext } from "../WizardContext"
import { buildDetailsPayload } from "../mappers/toApiPayload"
import { ExperienceInfo } from "../components/details/ExperienceInfo/ExperienceInfo"
import { ExperienceDetails } from "../components/details/ExperienceDetails/ExperienceDetails"
import { AdditionalDetails } from "../components/details/AdditionalDetails/AdditionalDetails"
import { PublishingSettings } from "../components/details/PublishingSettings/PublishingSettings"
import { EXPERIENCE_TYPES } from "constants/experiences"

export const DetailsStep = () => {
  const { form, stepSaveHandlersRef, trip } = useWizardContext()
  const [searchParams] = useSearchParams()
  const listingType = searchParams.get("type")
  // For existing trips, trust the server value. URL param is only the fallback for new experiences
  // before the first save sets experience_type on the record.
  const experienceType = trip?.experience_type
    ?? (listingType === EXPERIENCE_TYPES.ticketed ? EXPERIENCE_TYPES.ticketed : EXPERIENCE_TYPES.private)

  useEffect(() => {
    stepSaveHandlersRef.current["details"] = async () => {
      await form.validateFields(["title", "categories", "description", "marketplace_tags"])
      const formValues = form.getFieldsValue()
      return buildDetailsPayload(formValues, { experienceType })
    }
    return () => {
      delete stepSaveHandlersRef.current["details"]
    }
  }, [form, stepSaveHandlersRef, experienceType])

  const isPrivate = experienceType === EXPERIENCE_TYPES.private

  return (
    <div>
      <ExperienceInfo form={form} />
      <ExperienceDetails form={form} />
      {isPrivate && <AdditionalDetails form={form} />}
      <PublishingSettings form={form} />
    </div>
  )
}
